<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        serial
        :columns="columns"
        @fetch="fetch"
        v-model:search="queryForm"
        ref="tableRef"
        tableId="DcCosTransactionVolume"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item name="customerName" label="客户名称">
              <a-input v-model:value="queryForm.customerName" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item name="arkCode" label="子客户代码">
              <a-input v-model:value="queryForm.arkCode" allowClear placeholder="请输入" />
            </dc-form-item>
          </a-form>
        </template>
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'action'">
            <more-button>
              <a-button type="link" @click="addEdit(record)" v-permission="'fbu_tranvolume_edit_btn'">编辑</a-button>
              <a-button type="link" @click="deleteRow(record)" v-permission="'fbu_tranvolume_delete_btn'"
                >删除</a-button
              >
            </more-button>
          </template>
        </template>
        <template #button>
          <ButtonWrapperTips text="该成交额数据来源于BI">
            <a-button type="primary" @click="addEdit()" v-permission="'fbu_tranvolume_add_btn'">新增</a-button>
          </ButtonWrapperTips>
        </template>
      </cos-table>
      <editModal ref="editModalRef" @success="success" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts">
import editModal from './components/editModal.vue'
import Modal from '@/hooks/modalType'
import { reactive, ref, computed } from 'vue'
import { biTurnoverList, deleteBiTurnover } from '@/api/gucangSales/businessRuleSetting'

import { DcMessage } from '@dc-platform/dc-components'
import { BigScoreBakcData } from '@/typings/api/gucangSale'
import ButtonWrapperTips from '@/components/ButtonWrapperTips/index.vue'
export default { name: 'DcCosFbuTransactionVolume' }
</script>
<script setup lang="ts">
// eslint-disable-next-line func-call-spacing
const editModalRef = ref<{ toggle: (row?: BigScoreBakcData) => void }>()

const tableRef = ref()
const queryForm = reactive({
  arkCode: '',
  customerName: ''
})

// 获取列表
const fetch = async (params: object, callBack: (res: any) => void) => {
  const res = await biTurnoverList({ ...params })
  callBack(res)
}
const success = () => {
  tableRef.value.fetch()
}
const columns = computed(() => [
  { title: '客户名称', dataIndex: 'customerName' },
  { title: '子客户代码', dataIndex: 'arkCode' },
  { title: '成交额（万/RMB） ', dataIndex: 'amount' },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right'
  }
])
const addEdit = (_row?: BigScoreBakcData) => {
  editModalRef.value?.toggle(_row)
}
const deleteRow = (row: BigScoreBakcData) => {
  Modal.delete({
    name: row.customerName,
    onOk() {
      deleteBiTurnover(row.id).then(() => {
        DcMessage.success('删除成功')
        tableRef.value?.delFetch()
      })
    }
  })
}
</script>

<style scoped></style>
